import "bootstrap-icons/font/bootstrap-icons.css";

import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { eligibility } from "constants/eligibility";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import outline_check from "assets/images/outline_check.svg";

function ForeignExchange() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Treasury"
          title={`Foreign
              <span className="jumbotron-subtitle-2">
                Exchange
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Manage your foreign exchange requirements according to your
              business and risk profiles with Shariah-compliant foreign exchange
              services as we offer competitive foreign currency sales and
              purchases prices.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Our Products</h3>
          </div>
          <div className="col-xl-8">
            <p>
              <b>Foreign Exchange (FX) Spot</b>
            </p>
            <p>
              <li>
                Foreign exchange spot trading is an obligation to buy or sell
                one currency against a different currency for immediate
                delivery, rather than for future delivery. The standard
                settlement timeframe for FX Spot trades is T+2 days, i.e. 2
                business days from the date of trade execution.
              </li>
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Solution to the Bank’s customers
                </div>
                <div className="column-subheader-2">
                  To perform any foreign exchange transactions or payment
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">
                  Fast, efficient and competitive pricing
                </div>
                <div className="column-subheader-2">
                  For all your vanilla spot foreign exchange transactions{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Requirements</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility} >
              {eligibility.points.requirementforex.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ForeignExchange;
